import { createAction, props } from '@ngrx/store';
import { LoggedInModuleType } from '../../../shared/interfaces/logged-in-module.type';
import { User } from '../../../shared/interfaces/user.type';
import { HttpErrorResponse } from '@angular/common/http';


export const login = createAction('[Authentication] Login',
  props<{ email: string; password: string; rememberMe: boolean }>()
);

export const loginSuccess = createAction('[Authentication] Login Success',
  props<{ accessToken: string, refreshToken: string, user: User, loggedInModule: LoggedInModuleType, rememberMe: boolean }>()
);

export const twoFactorAuthRequired = createAction('[Authentication] Two Factor Auth Required',
  props<{ user: User, twoFactorAuthToken: string, rememberMe: boolean }>()
);

export const loginAreaChooseDialog = createAction('[Authentication] Login Area Choose Dialog',
  props<{ accessToken: string, refreshToken: string, user: User, roles: LoggedInModuleType[]; rememberMe: boolean; }>()
);

export const refreshTokenInProgress = createAction('[Authentication] Refresh Token In Progress');

export const refreshTokenSuccess = createAction('[Authentication] Refresh Token Success',
  props<{ accessToken: string, refreshToken: string, user: User, roles: LoggedInModuleType[]; }>()
);

export const loginFailure = createAction('[Authentication] Login Failure',
  props<{ error: HttpErrorResponse }>()
);

export const logout = createAction('[Authentication] Logout', props<{ manual?: boolean }>());

export const unAuthorized = createAction('[Authentication] UnAuthorized');

export const updateUser = createAction('[Authentication] Update Logged In User',
  props<{ user: User }>()
);

// Re-pulls the current user's roles/permissions from the server (GET /entrance/me)
// without a full re-login — used when a role/permission may have changed
// server-side while the user stays logged in (e.g. an admin edited their role).
export const refreshPermissions = createAction('[Authentication] Refresh Permissions');

export const refreshPermissionsSuccess = createAction('[Authentication] Refresh Permissions Success',
  props<{ user: Partial<User> }>()
);

export const refreshPermissionsFailure = createAction('[Authentication] Refresh Permissions Failure');


export const noAction = createAction('[Authentication] No Action');